export type TickerTheme = "light" | "dark" | "custom";

export type TickerColors = { background: string; text: string };

export type TickerAppearance = TickerColors & {
	headline: string;
	theme: TickerTheme;
	position: "bottom-right" | "bottom-left";
	showProgress: boolean;
};

/** Must match the presets the server resolves into the storefront payload. */
export const TICKER_PRESETS: Record<Exclude<TickerTheme, "custom">, TickerColors> = {
	light: { background: "#ffffff", text: "#111111" },
	dark: { background: "#111111", text: "#ffffff" },
};

export const tickerColors = (appearance: TickerAppearance): TickerColors =>
	appearance.theme === "custom"
		? { background: appearance.background, text: appearance.text }
		: TICKER_PRESETS[appearance.theme];
